/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/reset.css";
import "element-ui/lib/theme-chalk/index.css";
import "quill/dist/quill.core.css";
import 'quill/dist/quill.snow.css'
import MetaInfo from 'vue-meta-info'

Vue.use(MetaInfo)

Vue.config.productionTip = false;
Vue.prototype.NEWSIMGHOST = process.env.VUE_APP_NEWSIMG;
Vue.prototype.MAP = process.env.VUE_APP_MAP;
Vue.prototype.SITE = process.env.VUE_APP_SITE || 'main';
Vue.prototype.SITESTR = process.env.VUE_APP_SITE ? process.env.VUE_APP_SITE + '_' : '';
Vue.prototype.FJTECPATH = process.env.VUE_APP_FJTEC_PATH;
Vue.prototype.UPLOADFILE = process.env.VUE_APP_UPLOADFILE
Vue.prototype.FILESERVER = process.env.VUE_APP_FILESERVER
Vue.prototype.AGRIDATA = process.env.VUE_APP_AGRI_DATA
Vue.prototype.AGRIVIDEO = process.env.VUE_APP_AGRI_DATA_VIDEO
Vue.prototype.picSubfix = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'tif']

var ishttps = 'https:' == document.location.protocol ? true : false;
Vue.prototype.$isHttps = ishttps

import {
  Pagination,
  Menu,
  MenuItem,
  Button,
  Table,
  TableColumn,
  Breadcrumb,
  BreadcrumbItem,
  Tabs,
  TabPane,
  Icon,
  Row,
  Col,
  Card,
  Rate,
  Carousel,
  CarouselItem,
  Container,
  Main,
  Footer,
  Divider,
  Image,
  Input,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Popover,
  Steps,
  Step,
  FormItem,
  Form,
  Radio,
  Select,
  Option,
  MessageBox,
  Cascader,
  DatePicker,
  Upload,
  Loading,
  Message,
  RadioGroup,
  Tag,
  Alert
} from "element-ui";
Vue.use(Pagination);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Card);
Vue.use(Rate);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Container);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Divider);
Vue.use(Image);
Vue.use(Input);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Popover)
Vue.use(Steps)
Vue.use(Step)
Vue.use(FormItem);
Vue.use(Form);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(Cascader);
Vue.use(DatePicker);
Vue.use(Upload);
Vue.use(Tag);
Vue.use(Alert)
Vue.use(Loading.directive);
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;

// store.dispatch('queryAll');

router.beforeEach((to, from, next) => {
  if (to.name !== 'searchResult') {
    store.commit('setSearchKey', '')
  }
  store.commit("setCurrentRouteName", to.name);
  store.commit('setCurrentRouteParentPath', to.meta?.parent)
  next();
});



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");